export enum RoleEnum {
  // super admin
  SUPER = 'super',
  USER_UNIT_ROLE = 'unitAdmin',
  USER_GROUP_ADMIN_ROLE = 'groupAdmin',
  USER_SYSTEM_ROLE = 'system',
  USER_ROLE = 'user',
  // tester
  TEST = 'test',
}
